import instance from './base.service';

class CouponService {
  show(code) {
    return instance.get(`api/coupons/${code}.json`)
  }
}

export default new CouponService();
